export const BASE_URL = process.env.REACT_APP_API;
export const API_URL = process.env.REACT_APP_API + "/api";
export const URL_SOCKET = process.env.REACT_APP_SOCKET;

export const AI_ORDER_COMPLETION_PENDING = 1
export const AI_ORDER_COMPLETION_DONE = 2

export const PADZERO = 6;
export const type_control = [
  "Termostato programable",
  "Termostato no programable",
  "Termostato análogo",
  "Centralizado",
  "Tablero",
  "PLC",
  "Control remoto",
];

export const type_activitys = [
  { value: 1, label: "Caja de texto" },
  { value: 2, label: "Caja númerica" },
  { value: 3, label: "Casilla de verificación" },
  { value: 4, label: "Area de texto" },
];

export const stateOrder = [
  { value: 1, label: "Abierta" },
  { value: 2, label: "En ejecución" },
  { value: 3, label: "Finalizada" },
  { value: 4, label: "Pendiente por cotizar" },
  { value: 5, label: "Cotizada" },
  { value: 6, label: "Cerrada" },
  { value: 0, label: "Anulada" },
];

export const COLOR_DANGER = "#C0392B";
export const COLOR_SUCCESS = "#27AE60";
export const COLOR_WARNING = "#F1C40F";

export const ORDER_PENDIENT = 1;
export const ORDER_IN_PROGRESS = 2;
export const ORDER_DONE = 3;
export const ORDER_PENDIENT_QUOTATION = 4;
export const ORDER_QUOTATION_DONE = 5;
export const ORDER_CLOSED = 6;
export const ORDER_CANCELED = 0;

export const QUOTATION_PENDIENT = 1;
export const QUOTATION_DONE = 2;

// Maintenance status inside order.maintenances[].status — mirror of
// jag-backend/Constantes.js:56-58 (SOURCE OF TRUTH). Keep values in sync;
// drift silently breaks the order completion % in Order/Detail.
export const MTTO_STATUS_PENDIENT = 0;
export const MTTO_STATUS_INPROGRES = 1;
export const MTTO_STATUS_DONE = 2;

export const ROOM_GEO_USERS = "ROOM_GEO_USERS";
export const ROOM_UPDATE_USER = "ROOM_UPDATE_USER";
export const ROOM_MONITORING_USER = "ROOM_MONITORING_USER";

export const MEASURES = [
  { value: "u", label: "Unidad" },
  { value: "kg", label: "Kilogramos" },
  { value: "lb", label: "Libras" },
  { value: "oz", label: "Onzas" },
  { value: "gr", label: "Gramos" },
  { value: "l", label: "Litros" },
  { value: "ml", label: "Mililitros" },
  { value: "m", label: "Metros" },
];

export const ORDER_MATERIAL_STATE = [
  "Por aprobar",
  "Aprobado",
  "En proceso de compra",
  "Aprobar entrega",
  "En transporte",
  "Entregado",
];

export const MATERIAL_STATE_IN_ORDER = [
  "Pendiente",
  "Entrega total",
  "Entrega parcial",
  "Aprobar entrega",
  "Recibido parcial",
  "Recibido total",
];

export const EQUIPMENT_STATE = [
  { value: 1, label: "Funcionando correctamente", color: "#52BE80" },
  { value: 2, label: "Con novedad", color: "#F1C40F" },
  { value: 3, label: "Fuera de funcionamiento", color: "#E74C3C" },
];

export const PROJECY_ACTIVITY_STATE = [
  { value: 1, label: "A tiempo", color: "#5DADE2" },
  { value: 2, label: "Finalizado", color: "#52BE80" },
  { value: 4, label: "En progreso", color: "#F39C12" },
  { value: 3, label: "Retrasado", color: "#E74C3C" },
];
export const PROJECT_STATE = [
  { value: 0, label: "Pendiente", color: "#7F8C8D" },
  { value: 1, label: "En progreso", color: "#3498DB" },
  { value: 2, label: "Anulado", color: "#E74C3C" },
  { value: 3, label: "Finalizado", color: "#2ECC71" },
  { value: 4, label: "Retrasado", color: "#E74C3C" },
];

export const TOOL_STATE = [
  { value: 1, label: "Disponible", color: "#52BE80" },
  { value: 2, label: "En uso", color: "#3498DB" },
  { value: 3, label: "Averiada", color: "#E74C3C" },
  { value: 4, label: "En mantenimiento", color: "#F1C40F" },
  { value: 5, label: "Dada de baja", color: "#808B96" },
];

export const TOOL_GROUP = [
  "DE MANO",
  "MANTENIMIENTO PREVENTIVO",
  "MANTENIMIENTO CORRECTIVO",
];

export const ASSET_STATUS = [
  { value: "ACTIVO", label: "Activo", color: "#52BE80" },
  { value: "EN_REPARACION", label: "En reparación", color: "#F1C40F" },
  { value: "DE_BAJA", label: "De baja", color: "#808B96" },
  { value: "EN_BODEGA", label: "En bodega", color: "#3498DB" },
  { value: "PRESTADO", label: "Prestado", color: "#AF7AC5" },
  { value: "EXTRAVIADO", label: "Extraviado", color: "#E74C3C" },
  { value: "INACTIVO", label: "Inactivo", color: "#5D6D7E" },
];

// Values must match REST/solicitud-admin/Model.js's SOLICITUD_CATEGORIA/
// SOLICITUD_PRIORIDAD/SOLICITUD_ESTADO character-for-character.
export const SOLICITUD_CATEGORIA = [
  { value: "Mantenimiento", label: "Mantenimiento", color: "#3498DB" },
  { value: "Infraestructura", label: "Infraestructura", color: "#8E44AD" },
  { value: "Equipos", label: "Equipos", color: "#16A085" },
  { value: "Limpieza", label: "Limpieza", color: "#F1C40F" },
  { value: "Otro", label: "Otro", color: "#808B96" },
];

export const SOLICITUD_PRIORIDAD = [
  { value: "Baja", label: "Baja", color: "#52BE80" },
  { value: "Media", label: "Media", color: "#F1C40F" },
  { value: "Alta", label: "Alta", color: "#E74C3C" },
];

export const SOLICITUD_ESTADO = [
  { value: "ENVIADO", label: "Enviado", color: "#5DADE2" },
  { value: "PENDIENTE", label: "Pendiente", color: "#F1C40F" },
  { value: "RESUELTA", label: "Resuelta", color: "#52BE80" },
];

// Values must match REST/solicitud-alta-usuario/Model.js's
// ESTADO_SOLICITUD_ALTA character-for-character.
export const SOLICITUD_ALTA_ESTADO = [
  { value: "ENVIADA", label: "Enviada", color: "#5DADE2" },
  { value: "APROBADA", label: "Aprobada", color: "#52BE80" },
  { value: "RECHAZADA", label: "Rechazada", color: "#E74C3C" },
  { value: "COMPLETADA", label: "Completada", color: "#808B96" },
];

export const TOOL_ORDER_STATE = [
  { value: 1, label: "Pendiente", color: "#F7DC6F" },
  { value: 2, label: "Aprobada", color: "#5DADE2" },
  { value: 3, label: "Entregada", color: "#99A3A4" },
  { value: 4, label: "Retornada", color: "#2ECC71" },
  { value: 0, label: "Anulada", color: "#17202A" },
];

export const TIPOS_DE_COTIZACIONES = [
  { value: "M", label: "Mantenimiento preventivo" },
  { value: "C", label: "Mantenimiento correctivo" },
  { value: "P", label: "Proyecto" },
];

export const CONCEPT_LABOUR = 'manoObra'

export const CURRENCY_INPUT = {
  formatter: (value) =>
    `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
  parser: (value) => value.replace(/\$\s?|(,*)/g, "")
}

export const SPEND_PLAN_CONCEPTS = [
  { value: 'equipos',      label: 'Equipos',      color: '#1D4ED8' },
  { value: 'materiales',   label: 'Materiales',   color: '#0D9488' },
  { value: 'contratistas', label: 'Contratistas', color: '#7C3AED' },
  { value: CONCEPT_LABOUR, label: 'Mano de obra', color: '#EA580C' },
  { value: 'transporte',   label: 'Transporte',   color: '#CA8A04' },
  { value: 'viaticos',     label: 'Viáticos',     color: '#DC2626' },
  { value: 'otros',        label: 'Otros',        color: '#6B7280' },
]


export const CDN = process.env.REACT_APP_CDN

export const spend_plan_administrative_percentage = 16
export const spend_plan_sales_percentage = 6
export const spend_plan_warranty_percentage = 3